import { jsPDF } from "jspdf";
import { PDFDocument } from "pdf-lib";
import saveAs from "file-saver";
import { font } from "../../assets/inter";
import { font2 } from "../../assets/playfair.js";
import { font3 } from "../../assets/playfairitalic.js";
import { font4 } from "../../assets/interbold.js";
import { font5 } from "../../assets/plaifairbold";
import { templatesWithChapter, User } from "../EditPanel/types";
import { preloadImages, getBlankImage } from "./imageUtils";
import { formatDate, hasEmoji, drawTextOnCanvas } from "./helpers";

function addFooter(
  doc: jsPDF,
  pageNumber: number,
  authorName: string,
  bookName: string,
  change: number
) {
  doc.setFont("Playfair");
  doc.setFontSize(36);
  const pageWidth = doc.internal.pageSize.width;
  const leftMargin = 160 + change;
  const rightMargin = 160 + change;
  const bottomY = 1450 + change;

  const isEvenPage = pageNumber % 2 === 0;
  const authorOrBookName = isEvenPage ? authorName : bookName;
  let footerSize;
  if (authorName.length > 25) {
    footerSize = isEvenPage ? 36 : 30;
  } else {
    footerSize = isEvenPage ? 36 : 36;
  }

  const authorOrBookNameWidth = doc.getTextWidth(authorOrBookName);
  const pageNumberWidth = doc.getTextWidth(`${pageNumber}`);

  const authorOrBookNameX = isEvenPage
    ? pageWidth - rightMargin - authorOrBookNameWidth
    : leftMargin;
  const pageNumberX = isEvenPage
    ? leftMargin
    : pageWidth - rightMargin - pageNumberWidth;

  doc.setFontSize(footerSize);
  doc.text(authorOrBookName, authorOrBookNameX, bottomY);
  doc.setFontSize(36);
  doc.text(`${pageNumber}`, pageNumberX, bottomY);
}

export const generatePDF = async (
  user: User,
  change: number,
  isNew: boolean,
  predislovie: string
) => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "px",
    format: [1068 + change * 2, 1603 + change * 2],
  });

  const photosToPdf = user.photos.filter((photo) => photo.questionToPrecede);
  user.photos = await preloadImages(photosToPdf, change);

  let pageNumber = 1;

  const Inter = font;
  doc.addFileToVFS("Inter.ttf", Inter);
  doc.addFont("Inter.ttf", "Inter", "normal");
  doc.setFont("Inter");
  const Playfair = font2;
  doc.addFileToVFS("Playfair.ttf", Playfair);
  doc.addFont("Playfair.ttf", "Playfair", "normal");
  doc.setFont("Playfair");
  const PlayfairItalic = font3;
  doc.addFileToVFS("PlayfairItalic.ttf", PlayfairItalic);
  doc.addFont("PlayfairItalic.ttf", "PlayfairItalic", "normal");
  const PlayfairBold = font5;
  doc.addFileToVFS("PlayfairBold.ttf", PlayfairBold);
  doc.addFont("PlayfairBold.ttf", "PlayfairBold", "normal");
  const InterBold = font4;
  doc.addFileToVFS("InterBold.ttf", InterBold);
  doc.addFont("InterBold.ttf", "InterBold", "normal");

  // Add title page
  doc.setFontSize(38);
  doc.text(user.authorName, 534 + change, 170 + change, { align: "center" });
  doc.setFontSize(60);
  const paddingLeft = 90;
  const paddingRight = 90;
  const textWidth = 1068 - paddingLeft - paddingRight;
  doc.text(user.bookName, 534 + change, 801 + change, {
    align: "center",
    maxWidth: textWidth,
  });
  doc.setFontSize(38);
  doc.text("Comabooks Publishing House", 534 + change, 1390 + change, {
    align: "center",
  });
  doc.text("2026", 534 + change, 1450 + change, { align: "center" });
  doc.addPage();
  pageNumber++;

  if (templatesWithChapter.includes(user.questionTemplates[0].id)) {
    doc.addPage();
    pageNumber++;

    doc.setFont("Playfair");
    doc.setFontSize(38);
    if (user.questionTemplates[0].id === "66163e630f78aa6b9f522b09") {
      doc.text("Мазмұны", 534 + change, 170 + change, { align: "center" });
    } else if (user.questionTemplates[0].id === "66137cae18ab6072f1cea1df") {
      doc.text("Content", 534 + change, 170 + change, { align: "center" });
    } else {
      doc.text("Cодержание", 534 + change, 170 + change, { align: "center" });
    }
    doc.setFont("Playfair");
    doc.setFontSize(38);

    doc.addPage();
    pageNumber++;
  }

  doc.addPage();
  pageNumber++;

  // Add another title page
  doc.setFont("Playfair");
  doc.setFontSize(32);
  if (user.questionTemplates[0].id === "66163e630f78aa6b9f522b09") {
    doc.text("Алғы сөз", 534 + change, 731 + change, { align: "center" });
  } else if (user.questionTemplates[0].id === "66137cae18ab6072f1cea1df") {
    doc.text("Introduction", 534 + change, 731 + change, { align: "center" });
  } else {
    doc.text("Предисловие", 534 + change, 731 + change, { align: "center" });
  }

  doc.setFontSize(110);
  if (user.questionTemplates[0].id === "66163e630f78aa6b9f522b09") {
    doc.text("Баспадан", 534 + change, 831 + change, { align: "center" });
  } else if (user.questionTemplates[0].id === "66137cae18ab6072f1cea1df") {
    doc.text("Publisher", 534 + change, 831 + change, { align: "center" });
  } else {
    doc.text("От издательства", 534 + change, 831 + change, {
      align: "center",
    });
  }
  doc.addPage();
  pageNumber++;

  // Add the last blank page
  doc.addPage();
  pageNumber++;

  // Start adding content from here
  doc.setFont("Playfair");
  doc.setFontSize(38);
  doc.text(predislovie, 150 + change, 412 + change, {
    maxWidth: 868,
  });

  addFooter(doc, pageNumber, user.authorName, user.bookName, change);
  doc.addPage();
  pageNumber++;

  // Add another blank page
  doc.addPage();
  pageNumber++;

  let currentChapter: string | null = null;
  let currentChapterNumber = 1;

  const addChapterPage = (chapter: string) => {
    doc.setFont("Playfair");
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(40);
    if (user.questionTemplates[0].id === "66163e630f78aa6b9f522b09") {
      doc.text(`${currentChapterNumber} Бөлім`, 534 + change, 741 + change, {
        align: "center",
      });
    } else if (user.questionTemplates[0].id === "66137cae18ab6072f1cea1df") {
      doc.text(
        `Chapter ${currentChapterNumber}`,
        534 + change,
        741 + change,
        {
          align: "center",
        }
      );
    } else {
      doc.text(`Глава ${currentChapterNumber}`, 534 + change, 741 + change, {
        align: "center",
      });
    }
    doc.setFontSize(110);
    doc.text(chapter, 534 + change, 831 + change, { align: "center" });
    pageNumber++;
    currentChapterNumber++;
    doc.addPage();
  };

  const updateTOC = (chapter: string) => {
    if (templatesWithChapter.includes(user.questionTemplates[0].id)) {
      doc.setPage(3);
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(38);
      doc.setFont("Playfair");
      if (chapter === "Мы") {
        doc.text(
          `Глава 1: ${chapter}......................................................................${pageNumber}`,
          150 + change,
          300 + change
        );
      } else if (chapter === "Она" || chapter === "Он") {
        doc.text(
          `Глава 2: ${chapter}..................................................................${pageNumber}`,
          150 + change,
          340 + change
        );
      } else if (chapter === "Біз") {
        doc.text(
          `1 Бөлім: ${chapter}....................................................................${pageNumber}`,
          150 + change,
          300 + change
        );
      } else if (chapter === "Ол") {
        doc.text(
          `2 Бөлім: ${chapter}..................................................................${pageNumber}`,
          150 + change,
          340 + change
        );
      } else if (chapter === "Егер де..") {
        doc.text(
          `3 Бөлім: ${chapter}......................................................${pageNumber}`,
          150 + change,
          380 + change
        );
      } else if (chapter === "We") {
        doc.text(
          `Chapter 1 ${chapter}..................................................................${pageNumber}`,
          150 + change,
          300 + change
        );
      } else if (chapter === "He" || chapter === "She") {
        doc.text(
          `Chapter 3: ${chapter}..................................................................${pageNumber}`,
          150 + change,
          340 + change
        );
      } else if (chapter === "What if..") {
        doc.text(
          `Chapter 3: ${chapter}..................................................................${pageNumber}`,
          150 + change,
          380 + change
        );
      } else {
        doc.text(
          `Глава 3: ${chapter}......................................................${pageNumber}`,
          150 + change,
          380 + change
        );
      }

      doc.setPage(pageNumber);
    }
  };

  const filteredPairs = user.questionAnswerPairs.filter((pair) => !pair.isRemoved);

  for (let index = 0; index < filteredPairs.length; ++index) {
    const pair = filteredPairs[index];

    if (index > 0) {
      doc.addPage();
      pageNumber++;
    }

    if (
      user.questionTemplates[0].id === "65dda647dc778d94d0928969" ||
      user.questionTemplates[0].id === "660e02b2ce933929f288c10c" ||
      user.questionTemplates[0].id === "66163e630f78aa6b9f522b09" ||
      user.questionTemplates[0].id === "660e255e4d408cc2c1155322" ||
      user.questionTemplates[0].id === "65ec32bffc68f8ec35c47182" ||
      user.questionTemplates[0].id === "66137cae18ab6072f1cea1df"
    ) {
      if (pair.chapter !== currentChapter) {
        updateTOC(pair.chapter!);
        addChapterPage(pair.chapter!);
        currentChapter = pair.chapter!;
      }
    }

    doc.setDrawColor(0);
    doc.setFillColor(255, 255, 255);
    doc.setTextColor(0, 0, 0);
    doc.rect(140, 155, 1068 - 140 * 2, 1603 - 155 * 2, "F");
    addFooter(doc, pageNumber, user.authorName, user.bookName, change);

    doc.setFont("Playfair");
    doc.setFontSize(36);
    const questionX = 140 + 20 + change;
    let questionY = 195 + change;

    let answerY: number;

    if (pair.isQuestionHidden) {
      answerY = 195;
    } else {
      answerY = questionY + 100;
    }

    if (!pair.isQuestionHidden) {
      doc.text(
        pair.clientQuestion !== "" && pair.clientQuestion !== "-"
          ? pair.clientQuestion
          : pair.question,
        questionX,
        questionY,
        {
          maxWidth: 1068 - 140 * 2 - 20,
        }
      );
    }

    const estimatedLines = Math.ceil(
      doc.getTextWidth(pair.question) / (1068 - 140 * 2 - 20)
    );
    answerY += estimatedLines * 24;

    doc.setFont("Playfair");
    doc.setFontSize(80);
    const lineHeight = 48 * 1.6;
    const pageHeight = 1603 - 205;
    const contentWidth = 1068 - 140 * 2 - 20;
    const bottomMargin = 100;

    const answerLines = doc.splitTextToSize(pair.answer, contentWidth);
    for (let i = 0; i < answerLines.length; i++) {
      let line = answerLines[i];
      if (Array.isArray(line)) {
        line = line.join(" ");
      }

      if (answerY + lineHeight > pageHeight - bottomMargin) {
        if (answerLines.length - i <= 2) {
          for (; i < answerLines.length; i++) {
            line = answerLines[i];
            if (Array.isArray(line)) {
              line = line.join(" ");
            }
            if (hasEmoji(line)) {
              const canvas = drawTextOnCanvas(line, 200, "Playfair");
              if (canvas) {
                const imgData = canvas.toDataURL("image/png");
                doc.addImage(imgData, "PNG", questionX, answerY - 55, 724, 77);
              }
            } else {
              doc.setFont("Playfair");
              doc.setFontSize(80);
              doc.text(line, questionX, answerY);
            }
            answerY += lineHeight;
          }
          break;
        } else {
          doc.addPage();
          answerY = 155 + 40 + change;
          pageNumber++;
          addFooter(doc, pageNumber, user.authorName, user.bookName, change);
        }
      }

      if (hasEmoji(line)) {
        const canvas = drawTextOnCanvas(line, 200, "Playfair");
        if (canvas) {
          const imgData = canvas.toDataURL("image/png");
          doc.addImage(imgData, "PNG", questionX, answerY - 55, 724, 77);
        }
      } else {
        doc.setFont("Playfair");
        doc.setFontSize(80);
        doc.text(line, questionX, answerY);
      }
      answerY += lineHeight;
    }

    const photosToPlace = user.photos.filter(
      (photo) => photo.questionToPrecede === pair.question
    );

    for (const photo of photosToPlace) {
      const imgData = photo.imgData;
      doc.addPage();

      const addPhotoWithContent = (yPosition: number) => {
        doc.addImage(
          imgData,
          "JPEG",
          0,
          0,
          1068 + change * 2,
          1603 + change * 2,
          undefined,
          "FAST"
        );

        if (!photo.hideDate) {
          doc.setFont("Playfair");
          doc.setFontSize(42);
          const formattedDate = formatDate(photo.date);
          if (photo.status === "vertical" || photo.status === "square" || photo.status === "horizontal") {
            doc.text(formattedDate, 534 + change, 130 + change, { align: "center" });
          } else {
            doc.setTextColor(255, 255, 255);
            doc.text(formattedDate, 534 + change, yPosition + change, { align: "center" });
          }
        }

        if (!photo.hideDescription) {
          const textPaddingLeft = 200;
          const textPaddingRight = 200;
          const descTextWidth = 1068 - textPaddingLeft - textPaddingRight;

          if (photo.status === "vertical" || photo.status === "square" || photo.status === "horizontal") {
            doc.setFont("PlayfairBold");
            doc.setFontSize(42);
            const descY = photo.hideDate ? 130 : 170;
            doc.text(photo.description, 534 + change, descY + change, {
              align: "center",
              maxWidth: descTextWidth,
            });
          } else {
            doc.setFont("PlayfairItalic");
            doc.setFontSize(42);
            doc.setTextColor(255, 255, 255);
            const descY = photo.hideDate ? yPosition : yPosition + 80;
            doc.text(photo.description, 534 + change, descY + change, {
              align: "center",
              maxWidth: descTextWidth,
            });
          }
        }
        doc.setTextColor(0, 0, 0);
      };

      if (photo.status === "center") {
        addPhotoWithContent(851);
      } else if (photo.status === "top") {
        addPhotoWithContent(200);
      } else if (photo.status === "bottom") {
        addPhotoWithContent(1100);
      } else if (
        photo.status === "vertical" ||
        photo.status === "square" ||
        photo.status === "horizontal"
      ) {
        addPhotoWithContent(130);
      }

      pageNumber++;
      if (
        photo.status === "vertical" ||
        photo.status === "square" ||
        photo.status === "horizontal"
      ) {
        doc.setTextColor(0, 0, 0);
      } else {
        doc.setTextColor(255, 255, 255);
      }
      addFooter(doc, pageNumber, user.authorName, user.bookName, change);
    }

    const blanksToPlace = user.blanks.filter(
      (blank) => blank.questionToPrecede === pair.question
    );
    for (const blank of blanksToPlace) {
      doc.addPage();
      if (blank.photoUrl) {
        const blankImgData = await getBlankImage(blank.photoUrl, change);
        doc.addImage(
          blankImgData,
          "JPEG",
          0,
          0,
          1068 + change * 2,
          1603 + change * 2,
          undefined,
          "FAST"
        );
      }
      pageNumber++;
    }
    addFooter(doc, pageNumber, user.authorName, user.bookName, change);
  }

  doc.addPage();
  doc.setFont("Playfair");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(100);
  if (user.questionTemplates[0].id === "66163e630f78aa6b9f522b09") {
    doc.text("Соңы", 534 + change, 801 + change, { align: "center" });
  } else {
    doc.text("Конец", 534 + change, 801 + change, {
      align: "center",
      maxWidth: 844,
    });
  }
  pageNumber++;

  doc.addPage();
  pageNumber++;

  const originalBytes = doc.output("arraybuffer");

  if (!isNew) {
    const pdfDoc = await PDFDocument.load(originalBytes);

    const targetWidthMm = 126;
    const targetHeightMm = 186;

    const newWidth = (targetWidthMm / 25.4) * 72;
    const newHeight = (targetHeightMm / 25.4) * 72;

    pdfDoc.getPages().forEach((page) => {
      const { width, height } = page.getSize();

      const scale = newWidth / width;
      const scaledHeight = height * scale;

      page.scaleContent(scale, scale);
      page.setSize(newWidth, newHeight);

      const excessH = scaledHeight - newHeight;
      if (excessH > 0) {
        page.translateContent(0, -excessH / 2);
      }
    });

    const scaledBytes = await pdfDoc.save();
    const scaledBlob = new Blob([scaledBytes], { type: "application/pdf" });
    saveAs(scaledBlob, `${user.authorName}_печать_126x186.pdf`);
  } else {
    const pdfDoc = await PDFDocument.load(originalBytes);

    const targetWidthIn = 4.72;
    const newWidth = targetWidthIn * 72;
    const originalRatio = 1603 / 1068;
    const newHeight = newWidth * originalRatio;

    pdfDoc.getPages().forEach((page) => {
      const { width } = page.getSize();
      const scale = newWidth / width;

      page.scaleContent(scale, scale);
      page.setSize(newWidth, newHeight);
    });

    const scaledBytes = await pdfDoc.save();
    const scaledBlob = new Blob([scaledBytes], { type: "application/pdf" });
    saveAs(scaledBlob, `${user.authorName}_печать_4.72in.pdf`);
  }
};
